import { api } from '~/redux/api/createApi';
import { Nullable } from '~/types/Nullable';

import { TargetEntity, TargetEntityDetails } from '../types/entity';

export const useResolveTargetEntityDetails = (
  targetEntity: Nullable<TargetEntity>,
): [Nullable<TargetEntityDetails>, boolean] => {
  const {
    data: targetEntityDetails = null,
    isFetching: isResolvingTargetEntity,
  } = api.endpoints.resolvePromptModelTargetEntityDetails.useQuery(
    {
      // Query will be skipped if targetEntity is null
      entity: targetEntity!,
    },
    {
      skip: targetEntity === null,
    },
  );

  return [targetEntityDetails, isResolvingTargetEntity];
};
